import React from 'react';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import DonutChart from '@/pages/dashboard/_charts/DonutChart';
import colors from 'tailwindcss/colors';
import {useProjectsContext} from "@/pages/dashboard/ProjectsContext";

/**
 * QuestionCreatorYear Component
 *
 * Displays a donut chart showing the breakdown of who invited partners to projects
 * (educators vs. stewards) for the current school year.
 *
 * @param {Object} props - Component props
 * @param {string} [props.subtitle] - Optional subtitle for the chart
 */
export default function QuestionCreatorYear(props) {
  const {subtitle} = props;
  const {filteredInvitations, isLoadingInvitations} = useProjectsContext();

  // Show loading state while projects are being fetched
  if (isLoadingInvitations) {
    return (
      <ChartLoader
        title="Breakdown of who invited the partner"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  // Chart labels for the two categories
  const labels = ['Invited by Educator', 'Invited by Steward']

  // Calculate total invites from educators (connect + decline + pending questions)
  const totalInvites = filteredInvitations.length

  // Calculate total invites from stewards
  const totalStewardInvites = filteredInvitations.reduce((acc, invitation) => {
    if (invitation.projectCreatorId === invitation.creatorId) {
      return acc;
    }
    return acc + 1;
  }, 0);

  // Educator invites = Total invites - Steward invites
  const educatorInvites = totalInvites - totalStewardInvites

  // Data series for the donut chart [educator invites, steward invites]
  const series = [educatorInvites, totalStewardInvites]

  return (
    <DonutChart
      title="Breakdown of who invited the partner"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],  // Color for educator invites
        colors.yellow['400']    // Color for steward invites
      ]}
    />
  );
}
